var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pn dinline-block vtop ofhidden br5 pl25 mb15"},[_vm._v("\n  高起专函授：联系电话 "),_c('span',{staticClass:"fbold"},[_vm._v(_vm._s(_vm.item.phone))]),_vm._v("  "+_vm._s(_vm.item.name)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2887ff0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/about/teacher.vue
// module id = null
// module chunks = 